import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'BASEBOARD',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});


// Fetch baseboard action creators

export const fetchBaseboardInit = () => {
    return crudActions.fetchInit();
};
export const fetchBaseboardStart = () => {
    return crudActions.fetchStart();
};
export const fetchBaseboardSuccess = (fetchBaseboardCount, listBaseboardCount) => {
    return crudActions.fetchSuccess(fetchBaseboardCount, listBaseboardCount);
};
export const fetchBaseboardFail = () => {
    return crudActions.fetchFail();
};


export const fetchBaseboardCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchBaseboardStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchBaseboardSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchBaseboardFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch baseboard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchBaseboardFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch baseboard."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchBaseboard = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchBaseboardStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchBaseboardSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchBaseboardFail());
            return []

        } catch (error) {
            dispatch(fetchBaseboardFail());
            return []

        }
    }
}


// Load baseboard action creators
export const loadBaseboardInit = () => {
    return crudActions.loadInit();
};
export const loadBaseboardStart = () => {
    return crudActions.loadStart();
};
export const loadBaseboardSuccess = loadedBaseboard => {
    return crudActions.loadSuccess(loadedBaseboard);
};
export const loadBaseboardFail = error => {
    return crudActions.loadFail(error);
};
export const loadBaseboard = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};
// Create Baseboard  action creators
export const createBaseboardInit = () => {
    return crudActions.createInit();
};
export const createBaseboardStart = () => {
    return crudActions.createStart();
};
export const createBaseboardSuccess = createdBaseboard => {
    return crudActions.createSuccess(createdBaseboard);
};
export const createBaseboardFail = error => {
    return crudActions.createFail(error);
};

export const createBaseboard = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createBaseboardStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createBaseboardSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created baseboard.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createBaseboardFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create baseboard."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create baseboard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createBaseboardFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit Baseboard  action creators
export const editBaseboardInit = () => {
    return crudActions.editInit();
};
export const editBaseboardStart = () => {
    return crudActions.editStart();
};
export const editBaseboardSuccess = editedBaseboard => {
    return crudActions.editSuccess(editedBaseboard);
};
export const editBaseboardFail = error => {
    return crudActions.editFail(error);
};
export const editBaseboard = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBaseboardStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editBaseboardSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated baseboard.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editBaseboardFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit baseboard."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit baseboard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editBaseboardFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete baseboard action creators
export const bulkDeleteBaseboardsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteBaseboardsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBaseboardsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteBaseboardsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBaseboards = baseboardIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, baseboardIds);
    };
};

// Delete baseboard  action creators
export const deleteBaseboardInit = () => {
    return crudActions.deleteInit();
};
export const deleteBaseboardStart = () => {
    return crudActions.deleteStart();
};
export const deleteBaseboardSuccess = deletedBaseboard => {
    return crudActions.deleteSuccess(deletedBaseboard);
};
export const deleteBaseboardFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteBaseboard = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

export const setBaseboard = (data) => {
    return ({
        type: 'HANDLE_BASEBOARD',
        baseboard: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
